import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { Button, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./dialog.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function CustomDialog({
  open,
  children,
  handleSubmit,
  handleClose,
  title,
  width,
  sx,
  buttonTxt,
  className,
  alignActions = "end",
  btnColor = "#1b3e61",
  fullWidth = false,
  disabled = false,
  cancelBtn = false,
  isLoading = false,
  showCrossIcon = true,
  crossIconFunc,
  cancelBtnTxt = "Cancel",
  onClose = true,
  ...otherProps
}) {
  const defaultSx = {
    height: "90vh",
    "& .MuiPaper-root": {
      borderRadius: "8px",
      maxWidth: width ? width : "470px",
      backgroundColor: "#fff",
    },
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth={fullWidth}
        keepMounted
        onClose={onClose ? handleClose : () => {}}
        onClick={(e) => e.stopPropagation()}
        aria-describedby="alert-dialog-slide-description"
        className={`form-dialog ${className}`}
        sx={sx || defaultSx}
        {...otherProps}
      >
        <DialogTitle
          className="form-dialog-title"
          sx={{
            m: 0,
            p: 2,
          }}
        >
          {title}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={crossIconFunc ? crossIconFunc : handleClose}
          className={
            showCrossIcon
              ? "form-dialog-close-icon"
              : "form-dialog-close-icon pointer-events-none"
          }
        >
          {showCrossIcon && <CloseIcon />}
        </IconButton>

        <DialogContent className="form-dialog-content">
          {children}
        </DialogContent>
        {(buttonTxt || cancelBtn) && (
          <DialogActions
            className="confirmation-dialogAction"
            sx={{ justifyContent: alignActions }}
          >
            {buttonTxt && (
              <Button
                onClick={() => {
                  handleSubmit();
                }}
                // disabled={disabled || isLoading}
                variant="contained"
                type="submit"
                disabled={disabled || isLoading}
                loadingPosition="end"
                sx={{
                //   bgcolor: btnColor,
                  mr: cancelBtn ? "10px" : "0px",
                  fontSize: "16px",
                  padding: "10px 16px",
                  fontWeight: "600",
                  textTransform: "capitalize",
                  minWidth: "130px",
                }}
              >
                {buttonTxt}
              </Button>
            )}
            {cancelBtn && (
              <Button
                variant="outlined"
                sx={{
                  color: "#1B3E61",
                  border: "1px solid #1B3E61",
                  textTransform: "capitalize",
                  fontSize: "16px",
                  padding: "10px 16px",
                  fontWeight: "600",
                  opacity: "0.6",
                  minWidth: "130px",
                }}
                onClick={handleClose}
                disabled={isLoading}
                className="confirmation-action-btn"
              >
                {cancelBtnTxt}
              </Button>
            )}
          </DialogActions>
        )}
      </Dialog>
    </React.Fragment>
  );
}
